// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.help__page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1%;
}
.help__page h2 {
  font-size: 3rem;
}
@media (min-width: 691px) and (max-width: 850px) {
  .help__page h2 {
    font-size: 2rem;
  }
}
@media (max-width: 690px) {
  .help__page {
    padding: 3%;
  }
}
.help__page strong {
  margin-bottom: 2%;
}
.help__page strong a {
  color: #e63b11;
  text-decoration: none;
}
.help__page .help_form {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 20%;
}
.help__page .help_form select {
  border: 2px solid #e63b11;
  height: 2rem;
  border-radius: 0.5rem;
  margin-bottom: 5%;
  background-color: #fff;
  width: 100%;
}
.help__page .help_form label {
  font-size: 1.2rem;
}
.help__page .help_form input {
  width: 100%;
  border: 2px solid #e63b11;
  height: 2rem;
  border-radius: 0.5rem;
  margin-bottom: 5%;
  background-color: #fff;
}
.help__page .help_form textarea {
  border: 2px solid #e63b11;
  border-radius: 0.5rem;
  margin-bottom: 5%;
  width: 100%;
}
.help__page .help_form .captcha {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.help__page .help_form .captcha input {
  height: 2vh;
  width: 2vh;
}
.help__page .help_form .captcha p {
  font-size: 1.2rem;
}
.help__page .help_form button {
  align-self: center;
  background-color: #e63b11;
  width: 50%;
  color: #fff;
  text-transform: uppercase;
  border: none;
  height: 3rem;
  border-radius: 1.5rem;
  letter-spacing: 0.2rem;
  margin: 3% auto;
  transition: 1s ease-in-out;
  padding: 0.5% 1%;
  cursor: pointer;
}
.help__page .help_form button:hover {
  background-color: #000;
}
@media (min-width: 691px) and (max-width: 850px) {
  .help__page strong {
    width: 80%;
    margin: 2% auto;
    text-align: center;
  }
  .help__page .help_form {
    width: 75%;
  }
  .help__page .help_form input[type=date] {
    width: 100%;
  }
}
@media (max-width: 850px) {
  .help__page .help_form {
    width: 90%;
  }
  .help__page .help_form input[type=date] {
    width: 100%;
  }
}
@media (min-width: 851px) and (max-width: 1000px) {
  .help__page strong {
    width: 60%;
    text-align: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/styles/form.scss","webpack://./src/components/styles/variables.scss"],"names":[],"mappings":"AAEA;ECqCI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EDtCF,WAAA;AAEF;AAAE;EACE,eAAA;AAEJ;AACE;EACE;IACE,eAAA;EACJ;AACF;AAEE;EAdF;IAeI,WAAA;EACF;AACF;AACE;EAME,iBAAA;AAJJ;AADI;EACE,cCrBG;EDsBH,qBAAA;AAGN;AAGE;ECJE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;EDIA,UAAA;AACJ;AACI;EACE,yBAAA;EACA,YAAA;EACA,qBAAA;EACA,iBAAA;EACA,sBAAA;EACA,WAAA;AACN;AAEI;EACE,iBAAA;AAAN;AAGI;EACE,WAAA;EACA,yBAAA;EACA,YAAA;EACA,qBAAA;EACA,iBAAA;EACA,sBAAA;AADN;AAII;EACE,yBAAA;EACA,qBAAA;EACA,iBAAA;EACA,WAAA;AAFN;AAKI;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;AAHN;AAKM;EACE,WAAA;EACA,UAAA;AAHR;AAMM;EACE,iBAAA;AAJR;AAQI;EACE,kBAAA;EACA,yBC/EG;EDgFH,UAAA;EACA,WAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,qBAAA;EACA,sBAAA;EACA,eAAA;EACA,0BAAA;EACA,gBAAA;EACA,eAAA;AANN;AAQM;EACE,sBAAA;AANR;AAYE;EACE;IACE,UAAA;IACA,eAAA;IACA,kBAAA;EAVJ;EAaE;IACE,UAAA;EAXJ;EAYI;IACE,WAAA;EAVN;AACF;AAcE;EACE;IACE,UAAA;EAZJ;EAaI;IACE,WAAA;EAXN;AACF;AAeE;EACE;IACE,UAAA;IACA,kBAAA;EAbJ;AACF","sourcesContent":["@import \"./variables.scss\";\n\n.help__page {\n  @include columnStack;\n  padding: 1%;\n\n  h2 {\n    font-size: 3rem;\n  }\n\n  @media (min-width: $tabletMin) and (max-width: $tabletMax) {\n    h2 {\n      font-size: 2rem;\n    }\n  }\n\n  @media (max-width: $mobile) {\n    padding: 3%;\n  }\n\n  strong {\n    a {\n      color: $orange;\n      text-decoration: none;\n    }\n\n    margin-bottom: 2%;\n  }\n\n  .help_form {\n    @include columnStart;\n\n    width:20%;\n\n    select {\n      border: 2px solid $orange;\n      height: 2rem;\n      border-radius: .5rem;\n      margin-bottom: 5%;\n      background-color: #fff;\n      width: 100%;\n    }\n\n    label {\n      font-size: 1.2rem;\n    }\n\n    input {\n      width: 100%;\n      border: 2px solid $orange;\n      height: 2rem;\n      border-radius: .5rem;\n      margin-bottom: 5%;\n      background-color: #fff;\n    }\n\n    textarea {\n      border: 2px solid $orange;\n      border-radius: .5rem;\n      margin-bottom: 5%;\n      width: 100%\n    }\n\n    .captcha {\n      display: flex;\n      align-items: center;\n      justify-content: flex-start;\n\n      input {\n        height: 2vh;\n        width: 2vh;\n      }\n\n      p {\n        font-size: 1.2rem;\n      }\n    }\n\n    button {\n      align-self: center;\n      background-color: $orange;\n      width: 50%;\n      color: #fff;\n      text-transform: uppercase;\n      border: none;\n      height: 3rem;\n      border-radius: 1.5rem;\n      letter-spacing: .2rem;\n      margin: 3% auto;\n      transition: 1s ease-in-out;\n      padding: .5% 1%;\n      cursor: pointer;\n\n      &:hover {\n        background-color: #000;\n      }\n\n    }\n  }\n\n  @media (min-width: $tabletMin) and (max-width: $tabletMax) {\n    strong {\n      width: 80%;\n      margin: 2% auto;\n      text-align: center;\n    }\n\n    .help_form {\n      width: 75%;\n      input[type=date] {\n        width: 100%;\n      }\n    }\n  }\n\n  @media (max-width: $tabletMax) {\n    .help_form {\n      width: 90%;\n      input[type=date] {\n        width: 100%;\n      }\n    }\n  }\n\n  @media (min-width: $landsTabletMin) and (max-width: $landsTabletMax) {\n    strong {\n      width: 60%;\n      text-align: center;\n    }\n  }\n}","//colours\n$orange: #e63b11;\n$font: #000;\n$lightGrey: #d1d3d4;\n$darkGrey: #939598;\n$darkBlue: #01426a;\n$lightBlue: #77c5d5;\n\n//mobile breaks\n$mobilemin:100;\n$mobile: 690px;\n$tabletMin: 691px;\n$tabletMax: 850px;\n$landsTabletMin: 851px;\n$landsTabletMax: 1000px;\n$landsTabletMin2: 1000px;\n$landsTabletMax2: 1300px;\n$smallLaptopMin: 1301px;\n$smallLaptopMax: 1439px;\n$smallScreen: 1440px;\n$regularScreen: 1900px;\n$bigScreen: 1920px;\n$fourK: 2000px;\n\n@mixin columnStart{\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n}\n\n@mixin columnStartCenter{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n}\n\n@mixin columnStack{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n@mixin columnCenter{\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n}\n\n@mixin rowEven{\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n}\n\n@mixin rowEvenStart{\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-evenly;\n}\n\n@mixin rowBetween{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n@mixin rowBetweenStart{\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n}\n\n@mixin rowCenter{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n@mixin button {\n        background-color: $orange;\n        color: #fff;\n        text-transform: uppercase;\n        border: none;\n        // height: 3rem;\n        border-radius: 1.5rem;\n        letter-spacing: 0.1rem;\n        font-weight: 600;\n        // margin: 3% auto;\n        transition: background-color 0.3s ease;\n        padding: 0 2rem;\n        cursor: pointer;\n        \n        &:hover {\n          background-color: #000;\n        }\n      \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
